import React from "react";

import BooleanSelector from "./BooleanSelector";

export default function AllowNullBFarmexSelector(props) {
  return <BooleanSelector label="Permitir código Farmex nulo" {...props} />;
}
